"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @ignore
*/
exports.BLOCKSTACK_HANDLER = 'blockstack';
/**
* @ignore
*/
exports.BLOCKSTACK_STORAGE_LABEL = 'blockstack';
/**
* This constant is used in the [[redirectToSignInWithAuthRequest]]
*/
exports.DEFAULT_BLOCKSTACK_HOST = 'https://browser.blockstack.org/auth';
/**
* @ignore
*/
exports.DEFAULT_SCOPE = ["store_write" /* store_write */];
/**
* @ignore
*/
exports.BLOCKSTACK_APP_PRIVATE_KEY_LABEL = 'blockstack-transit-private-key';
/**
* @ignore
*/
exports.BLOCKSTACK_DEFAULT_GAIA_HUB_URL = 'https://hub.blockstack.org';
/**
* @ignore
*/
exports.DEFAULT_CORE_NODE = 'https://core.blockstack.org';
/**
* @ignore
*/
exports.NAME_LOOKUP_PATH = '/v1/names';
/**
* @ignore
*/
exports.LOCALSTORAGE_SESSION_KEY = 'blockstack-session';
//# sourceMappingURL=authConstants.js.map